import _ from 'lodash';
import moment from 'moment';
import ispList from '../components/checkout/CurrentConnection/isps.json';
import landlineList from '../components/checkout/CurrentConnection/landlines.json';
import FullAddressBuilder from './FullAddressBuilder';
import Configuration from '../common/Configuration.json';

const build = (signupDetails, plan, isContractSelected, withMobileDiscountInfo, isByoModemSelected) => {
  const homePageDetails = signupDetails.home;
  const checkoutDetails = signupDetails.form.checkout.values;
  const provider = signupDetails.plans.provider;
  const paymentDetails = signupDetails.payment;
  const bundleDiscount = withMobileDiscountInfo ? withMobileDiscountInfo.withMobileDiscount : false;
  const bundleDiscountAmount = bundleDiscount === true ? '10.00' : '0.00';
  const bundleMobile = withMobileDiscountInfo ? withMobileDiscountInfo.linkedMobile : '';
  // api expects this in format { id: 1, name: 'Random Provider' }
  const isps = _.map(ispList, o => ({ id: o.value, name: o.label }));
  const existingBroadbandProvider = _.find(isps, { id: checkoutDetails.currentBroadbandProvider });

  // api expects this in format { id: 1, name: 'Random Provider' }
  const landlineProviders = _.map(landlineList, o => ({ id: o.value, name: o.label }));
  const existingLandlineProvider = _.find(landlineProviders, { id: checkoutDetails.existingLandlineProvider });

  const requestASAP = checkoutDetails.connectionDate === 'asap';
  const dateToBeConnected = (!requestASAP && checkoutDetails.preferredDate) ?
                            moment(checkoutDetails.preferredDate, 'DD/MM/YYYY').valueOf() : moment().valueOf();
  const currentLandline = checkoutDetails.currentLandline === 'yes';

  const getCityAndPostCode = (city, postCode) => {
    if (city && postCode) {
      return `${city} ${postCode}`;
    }
    if (city) {
      return city;
    }
    if (postCode) {
      return postCode;
    }
    return '';
  };

  // construct delivery address
  const buildDeliveryAddress = () => {
    if (checkoutDetails.modemDelivery === 'same') {
      const fullName = `${checkoutDetails.firstName} ${checkoutDetails.lastName}`;
      const fullAddress = FullAddressBuilder.build(homePageDetails.selectedAddressParts);
      return `${fullName}, ${fullAddress}`;
    }
    return _.filter([
      checkoutDetails.modemName,
      checkoutDetails.modemCompany,
      checkoutDetails.modemAddress,
      checkoutDetails.modemSuburb,
      getCityAndPostCode(checkoutDetails.modemCity, checkoutDetails.modemPostcode)
    ], val => val && val.trim().length > 0).join(', ');
  };
  const deliveryAddress = buildDeliveryAddress();

  const productOffer = plan.name;

  const promotionCode = paymentDetails.promotionCode ? paymentDetails.promotionCode.replace(/\s/, '') : null;

  // construct the payload
  let payload = {
    // token: zuoraToken,
    address: homePageDetails.selectedAddressParts,
    productOffer,
    firstName: checkoutDetails.firstName,
    lastName: checkoutDetails.lastName,
    email: checkoutDetails.email,
    mobile: checkoutDetails.contactNumber,
    password: checkoutDetails.password,
    existingBroadbandProvider,
    existingProviderAccNo: checkoutDetails.providerAccountNumber,
    otherExistingBroadbandProvider: '',   // TODO NTH
    currentLandline,
    existingLandlineProvider,
    otherExistingLandlineProvider: '',    // TODO NTH
    essentialBusiness: checkoutDetails.isEssentialService,
    essentialBusinessCategory: checkoutDetails.essentialServiceType,
    essentialBusinessReason: checkoutDetails.essentialServiceReason,
    provider,
    requestASAP,
    dateToBeConnected,
    landlineDisconnectAccepted: currentLandline,
    landlineServicesDisconnectAccepted: currentLandline,
    smartSupportAccepted: true,
    receiveFutureOffersAccepted: checkoutDetails.receiveUpdates,
    promotionCode,
    validatedPromoCode: paymentDetails.validatedPromoCode,
    requestedStaticIpAddress: false,
    modem: {
      bigpipeModem: !isByoModemSelected,
      bringYourModem: isByoModemSelected,
      deliveryAddress,
      deliveryInstructions: checkoutDetails.modemDeliveryInstructions
    },
    clickTokenId: paymentDetails.clickDetails.clickTokenId,
    clickTransactionId: paymentDetails.clickDetails.clickTransactionId,
    clickSessionId: paymentDetails.clickDetails.clickSessionId,
    bundleDiscount,
    partner: homePageDetails.partner.name || ''
  };

  if (Configuration.offer.enabled) {
    payload = { ...payload, offerEnabled: Configuration.offer.enabled };
  }

  if (isContractSelected) {
    payload = { ...payload, creditAssessmentApplicationId: checkoutDetails.caApplicationId };
  }

  if (bundleDiscount) {
    payload = { ...payload, bundleDiscountAmount, bundleMobile };
  }

  return payload;
};

const SignupInfoBuilder = {
  build
};

export default SignupInfoBuilder;



/** WEBPACK FOOTER **
 ** ./src/common/SignupInfoBuilder.js
 **/